'use strict'

const userCodeLoaded = ({ pageId }) => ({ evid: 133, worker_id: pageId })

module.exports = { userCodeLoaded }
